export function getArticles() {
  return this.get('/websites', {py: true})
}

export function getArticleMessages(id) {
  return this.get(`/api/articles/${id}/messages`)
}

export function deleteArticle(id) {
  return this.del(`/delete/document/${id}`, {py: true})
}

export function uploadArticle(data) {
  return this.post('/upload/website', data, {py: true}).request
}
